import { Icon } from '@chakra-ui/react';

export default function SFPersonIconOutlined(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width='14px'
      height='15px'
      fill='currentColor'
      viewBox='0 0 14 15'
      {...props}
    >
      <path d='M7 7.36c-1.86 0-3.375-1.641-3.375-3.65C3.625 1.728 5.148.126 7 .126c1.867 0 3.375 1.57 3.375 3.57C10.375 5.711 8.859 7.36 7 7.36m0-1.18c1.148 0 2.117-1.102 2.117-2.485 0-1.367-.953-2.39-2.117-2.39-1.156 0-2.117 1.047-2.117 2.406 0 1.383.976 2.469 2.117 2.469m-4.914 8.414c-1.297 0-1.914-.39-1.914-1.25 0-2.047 2.586-5.008 6.828-5.008 4.234 0 6.82 2.96 6.82 5.008 0 .86-.617 1.25-1.914 1.25zm-.367-1.18H12.28c.203 0 .281-.055.281-.219 0-1.289-1.984-3.68-5.562-3.68-3.586 0-5.57 2.391-5.57 3.68 0 .164.086.22.289.22' />
    </Icon>
  );
}
